import { useState, useEffect } from "react";

const ChartSkeleton = () => {
  // Create pulse animation effect
  const [isPulsing, setIsPulsing] = useState(true);

  useEffect(() => {
    // Toggle the pulsing state every 1.5 seconds
    const interval = setInterval(() => {
      setIsPulsing((prev) => !prev);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full space-y-8">
      {/* Chart Container Skeleton */}
      <div className="w-full rounded-lg border border-n200 p-4 bg-p400 shadow-sm h-[450px]">
        <div className="flex justify-between items-center mb-4">
          <div
            className={`h-6 w-32 rounded bg-n100 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
          <div
            className={`h-6 w-24 rounded bg-n100 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
        </div>
        <div
          className={`h-64 w-full rounded bg-n100 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
      </div>

      {/* Markets Table Skeleton */}
      <div className="w-full rounded-lg border border-n200 p-4 bg-p400 shadow-sm">
        <div
          className={`h-6 w-48 rounded bg-n100 mb-4 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
        <div className="space-y-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex justify-between">
              <div
                className={`h-4 w-24 rounded bg-n100 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
              <div
                className={`h-4 w-16 rounded bg-n100 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
            </div>
          ))}
        </div>
      </div>

      {/* FiiDii Chart Skeleton */}
      <div className="w-full rounded-lg border border-n200 p-4 bg-p400 shadow-sm">
        <div
          className={`h-6 w-40 rounded bg-n100 mb-4 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
        <div
          className={`h-52 w-full rounded bg-n100 ${isPulsing ? "opacity-60" : "opacity-100"} transition-opacity duration-1000`}></div>
      </div>
    </div>
  );
};

export default ChartSkeleton;
